/**
 * Loading spinner.
 */

import React from 'react';
import { Spinner } from '@fluentui/react-components';

interface LoadingSpinnerProps {
  label?: string;
  size?: React.ComponentProps<typeof Spinner>['size'];
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label = 'Chargement...',
  size = 'small',
}) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
    <Spinner size={size} label={label} />
  </div>
);
